module.exports = __webpack_public_path__ + "yandex_kassa_ico_nal.0faefc7fd22c9fb9b39f18e8c5b91959.png";